<template>
  <div id="appRoot">
    <template v-if="!$route.meta.public">
      <v-app id="inspire" class="app">
        <v-form ref="form" lazy-validation>
          <app-drawer class="app--drawer"></app-drawer>         
          <app-toolbar class="app--toolbar" v-bind:class="{ 'toolbar-expanded': sidebarExpanded}"></app-toolbar>
          <v-main v-bind:class="{ 'v-main-expanded': !sidebarExpanded}">
             <div class="alert-internal"  v-if="roleAdmin && requestWithdraw && requestWithdraw.Total > 0">
              <i class="fa fa-exclamation-circle" aria-hidden="true"></i> {{ `Bạn có ${this.requestWithdraw ? this.requestWithdraw.Total : 0 } yêu cầu rút tiền chờ duyệt.` }}
             </div>
             <div class="alert-internal"  v-if="rolePayment && requestWithdraw && requestWithdraw.Total > 0">
              <i class="fa fa-exclamation-circle" aria-hidden="true"></i> {{ `Bạn có ${this.requestWithdraw ? this.requestWithdraw.Total : 0 } yêu cầu rút tiền cần hoàn thành.` }}
             </div>
             <div class="alert-internal" v-if="(rolePayment || roleAdmin) && financeSummary && financeSummary.Total">
              <i class="fa fa-exclamation-circle" aria-hidden="true"></i> {{ `Chênh lệch ví hệ thống và Số dư cuối TK ngân hàng ${financeSummary.Total}.` }}
             </div>
             <div class="alert-internal"  v-if="expiredContactCareShow">
              <i class="fa fa-exclamation-circle" aria-hidden="true"></i> {{ `Bạn có hành động chăm sóc khách hàng ${this.expiredContactCare && this.expiredContactCare.FullName ? this.expiredContactCare.FullName : '' } đến hạn` }}
             </div>
             <div class="alert-internal"  v-if="roleAdmin && znsNotiErr && znsNotiErr.Total > 0">
              <i class="fa fa-exclamation-circle" aria-hidden="true"></i> {{ `Gửi thông báo ZNS lỗi, vui lòng kiểm tra chi tiết.` }}
             </div>
            <!-- Page Header -->            
            <page-header v-if="$route.meta.breadcrumb"></page-header>
            <div class="page-wrapper">
              <router-view></router-view>
            </div>
            <!-- App Footer -->
            <v-footer height="auto" class="white pa-4 pt-8 app--footer">
              <span class="caption">UNISHIP.VN Design &copy; 2021</span>
              <v-spacer></v-spacer>
            </v-footer>
          </v-main>
          <!-- Go to top -->
          <app-fab></app-fab>
          <v-snackbar transition="slide-x-transition" :timeout="snackbar.timeout ? snackbar.timeout : 3000" :color="snackbar.color" v-model="snackbar.show" bottom left multi-line rounded>
            {{ snackbar.text }}
            <template v-slot:action="{ attrs }">
              <v-btn
                color="white"
                text
                v-bind="attrs"
                @click="snackbar.show = false"
              >
                X
              </v-btn>
            </template>
          </v-snackbar>
          <!-- <v-snackbar transition="slide-x-transition" :timeout="-1" :color="'#dc3545'" v-model="requestWithdraw" v-if="roleAdmin && requestWithdraw && requestWithdraw.Total > 0" bottom right multi-line rounded>
            {{ `Bạn có ${this.requestWithdraw ? this.requestWithdraw.Total : 0 } yêu cầu rút tiền chờ duyệt.` }}
          </v-snackbar>
          <v-snackbar transition="slide-x-transition" :timeout="-1" :color="'#dc3545'" v-model="requestWithdraw" v-if="rolePayment && requestWithdraw && requestWithdraw.Total > 0" bottom right multi-line rounded>
            {{ `Bạn có ${this.requestWithdraw ? this.requestWithdraw.Total : 0 } yêu cầu rút tiền cần hoàn thành.` }}
          </v-snackbar>
          <v-snackbar transition="slide-x-transition" :timeout="-1" :color="'#dc3545'" v-model="financeSummary" v-if="(rolePayment || roleAdmin) && financeSummary && financeSummary.Total > 0" bottom right multi-line rounded>
            {{ `Chênh lệch ví hệ thống và Số dư cuối TK ngân hàng.` }}
          </v-snackbar>
          <v-snackbar transition="slide-x-transition" :timeout="-1" :color="'#dc3545'" v-model="expiredContactCareShow" bottom right multi-line rounded>
            {{ `Bạn có hành động chăm sóc khách hàng ${this.expiredContactCare && this.expiredContactCare.FullName ? this.expiredContactCare.FullName : '' } đến hạn` }}
          </v-snackbar> -->
          <v-dialog v-model="delDialog" persistent max-width="320">
            <v-card>
              <v-toolbar flat dark height="35" color="oee-theme">
                <v-btn icon dark @click="delDialog = false">
                  <v-icon>fa-times-circle</v-icon>
                </v-btn>
                <v-spacer></v-spacer>
                <span>Xác nhận</span>
              </v-toolbar>
              <v-card-text style="margin-top: 20px" v-html="delMessage || 'Bạn có chắc chắn muốn xóa mục đã chọn?'"></v-card-text>
              <v-card-actions>
                <div class="flex-grow-1"></div>
                <v-btn color="gray darken-1" @click="delConfirmed">{{dialogOptions.ConfirmLabel || 'Đồng ý'}}</v-btn>
                <v-btn color="blue darken-1 white--text" autofocus @click="cancelAction">{{ dialogOptions.CancelLabel || 'Hủy'}}</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-form>
      </v-app>
    </template>
    <template v-else>
      <transition>
        <keep-alive>
          <router-view :key="$route.fullpath"></router-view>
        </keep-alive>
      </transition>
    </template>
  </div>
</template>

<script>
import AppDrawer from "@/components/AppDrawer";
import AppToolbar from "@/components/AppToolbar";
import AppFab from "@/components/AppFab";
import PageHeader from "@/components/PageHeader";
import AppEvents from "./event";
import { mapState } from "vuex";
import configs from "@/configs";
export default {
  components: {
    AppDrawer,
    AppToolbar,
    AppFab,
    PageHeader
  },
  data: () => ({
    confirmAction: "",
    dialogOptions: {},
    delMessage: "",
    delDialog: false,
    confirmResolver: null,
    delId: 0,
    rightDrawer: false,
    snackbar: {
      show: false,
      text: "",
      color: ""
    },
    expiredContactCareShow: false
  }),
  computed: {
    ...mapState("commons", {
      sidebarExpanded: "sidebarExpanded",
    }),
    ...mapState({
      expiredContactCare: state => state.commons.contactCareExpired,
      requestWithdraw: state => state.commons.requestWithdraw,
      financeSummary: state => state.commons.financeSummary,
      znsNotiErr: state => state.commons.znsNotiErr
    }),
    roleAdmin() {
      return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin;
    },
    rolePayment() {
      return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Payment) == configs.ROLE_TYPE.Payment;
    },
    withdraw_status() {
      return this.roleAdmin ? 1 : this.rolePayment ? 2 : 0;
    }
  },
  methods: {
    delConfirmed() {
      this.delDialog = false;
      if (this.confirmResolver) {
        this.confirmResolver(true); // Resolve the promise with true (confirmed)
        this.confirmResolver = null; // Reset resolver
      }
      else {
        if (this.confirmAction != '') {
          this.$root.$emit('CONFIRMED_ACTION', {action: this.confirmAction, id: this.delId});
        }
        else {
          this.$root.$emit('CONFIRMED_REMOVE_DATA', this.delId);
        }
        this.delId = 0;
        this.confirmAction = "";
      }
    },
    showConfirmation(message = 'Bạn có chắc chắn muốn thực hiện hành động này?') {
      this.delMessage = message;
      this.delDialog = true;
      return new Promise((resolve) => {
        this.confirmResolver = resolve; // Store the resolver
      });
    },
    cancelAction() {
      this.delDialog = false;
      if (this.confirmResolver) {
        this.confirmResolver(false); // Resolve the promise with false (cancelled)
      }
      this.confirmResolver = null; // Reset resolver
      this.$root.$emit('CANCEL_CONFIRMED_ACTION');
      this.delId = 0;
      this.confirmAction = "";
    },
    refresh_data() {
      if(this.$store.state.authentication.token != "") {
        this.$store.dispatch("roles/getList");
        this.$store.dispatch("authentication/me");
        this.$store.dispatch("commons/getExpiredContactCare");
        this.$store.dispatch("commons/getRequestWithdraw", {'status': this.withdraw_status});
        this.$store.dispatch("commons/getFinanceSummary");
        this.$store.dispatch("commons/getZnsNotiErr");
      }
    }
  },
  watch: {
    expiredContactCare: {
      handler: function (val, oldVal) {
          if (val) {
            this.expiredContactCareShow = true;
          } else {
            this.expiredContactCareShow = false;
          }
      },
    }
  },
  created() {
    AppEvents.forEach(item => {
      this.$on(item.name, item.callback);
    });
    window.getApp = this;
    window.getApp.$on("APP_DRAWER_TOGGLED", () => {
      this.$store.commit("commons/setSidebarExpanded", {
        expanded: !this.sidebarExpanded
      });
    });
  },
  mounted() {
    this.$root.$on("REQUEST_REFRESH_DATA", this.refresh_data);
    this.refresh_data();
  },
  beforeDestroy() {
    this.$root.$off("REQUEST_REFRESH_DATA", this.refresh_data);
  }
};
</script>

<style lang="stylus" scoped>
.setting-fab {
  top: 50% !important;
  right: 0;
  border-radius: 0;
}

.page-wrapper {
  min-height: calc(100vh - 64px - 50px - 81px);
}

.toolbar-expanded {
  padding: 0 0 0 230px !important;
}

.v-snack__wrapper p {
  margin: 0 0 0 0 !important;
}
</style>
